import React from 'react';

import APIModel from "../../Components/APIModel";
import {useTranslation, Trans} from "react-i18next";
import AppSidebar from '../../Layout/AppSidebar';
import AppHeader from '../../Layout/AppHeader';


const PaymentGates = (
    {
        match,
    }
) => {
    const {t, i18n} = useTranslation();

    const PAYMENT_GATES_COLUMNS = [
        {
            name: t('settings.payment_gates.column.name', 'Name'),
            selector: "name",
        },
        {
            name: t('settings.payment_gates.column.type', 'Type'),
            cell: row => <div>
                {t(row.type.name)}
            </div>
        },
    ];

    const url_string = window.location.href.toString().replaceAll("#", ''); //
    const url = new URL(url_string);
    const type = url.searchParams.get("type");
    const defaultData = {};
    if (type) {
        defaultData['type'] = {'id': parseInt(type, 10)}
    }
    return <APIModel
        heading={t('settings.payment_gates.page.title', 'Payment gateways')}
        subheading={<Trans i18nKey='settings.payment_gates.page.subtitle' t={t}>
            <div className='text-dark'>⚠️ You can learn more reading <a
                href={t('settings.payment_gates.page.url_help', 'https://help.1msg.io/ru/vizual_nyj_konstruktor_chat_botov/podklyuchenie_platezhnyh_sistem')}
                rel="noopener noreferrer" target='_blank'>payments gateways connection instructions</a></div>
        </Trans>}
        icon="pe-7s-credit icon-gradient bg-night-fade"
        apiPath='integrations/payment_gates'
        tableColumns={PAYMENT_GATES_COLUMNS}
        defaultData={defaultData}
        tableEmptyMessage={t('settings.payment_gates.list.message.no_data', 'No payment gateways are connected')}
        match={match}
        ComponentSidebar={<AppSidebar/>}
        ComponentHeader={<AppHeader/>}
    />;
};

export default PaymentGates;
